import { ChartArea } from './chartTypes/chartArea';
import { ChartLine } from './chartTypes/chartLine';
import { ChartBar } from './chartTypes/chartBar';
import { PieChart } from './chartTypes/pieChart';
import { AmChartsBase } from './chartTypes/amchartsBase';
import { StackedChart } from './chartTypes/stackedChart';
import { ChartRange } from './chartTypes/chartRange';
export class ChartFactory {
    /**
     * If the type property of the serie object is not undefined,
     * return it, otherwise return the default value of type.
     * @param {IChartSeries} serie - IChartSeries
     * @returns The type of the chart.
     */
    getChartType(serie) {
        const { type } = serie;
        return type;
    }
    /**
     * "This function creates a new instance of the AmChartsBase class and returns it."
     * @param {string | HTMLElement} rootElement - string | HTMLElement - the element where the chart
     * will be rendered
     * @param {TypeCharts} typeChart - TypeCharts - this is an enum that contains
     * the type of chart you want to create.
     * @param {any} typeCategory - any
     * @returns An instance of the AmChartsBase class.
     */
    createChart(rootElement, typeChart, typeCategory, model, rootLegendElement, chartOptions) {
        // Check if exist type
        const existType = this.checkIfExistType(typeChart);
        if (!existType)
            throw new Error('Type not exist or not supported');
        return new AmChartsBase(rootElement, typeChart, typeCategory, model, rootLegendElement, chartOptions);
    }
    /**
     * If the type of chart is area, create a new ChartArea object, if it's a line, create a new
     * ChartLine object, etc.
     * If the type not exists Throw a Error
     * @param {IChartSeries} serie - IChartSeries
     * @param {any} chart - Chart Object
     * @returns The return value is the chartObject.
     */
    createSerie(serie, chart) {
        const typeChart = this.getChartType(serie);
        const existType = this.checkIfExistType(typeChart);
        if (!existType)
            throw new Error('Type not exist or not supported');
        let chartObject = null;
        if (typeChart === 'area') {
            chartObject = new ChartArea(serie, chart);
        }
        else if (typeChart === 'line') {
            chartObject = new ChartLine(serie, chart);
        }
        else if (typeChart === 'range') {
            chartObject = new ChartRange(serie, chart);
        }
        else if (typeChart === 'bar') {
            chartObject = new ChartBar(serie, chart);
        }
        else if (typeChart === 'pieChart') {
            chartObject = new PieChart(serie, chart);
        }
        else if (typeChart === 'stacked') {
            chartObject = new StackedChart(serie, chart);
        }
        if (chartObject === null)
            throw new Error('Type not exist or not supported');
        return chartObject;
    }
    checkIfExistType(type) {
        const existTypes = ['area', 'line', 'bar', 'pieChart', 'stacked', 'range'];
        return existTypes.includes(type);
    }
}
//# sourceMappingURL=chartFactory.js.map